import { Announcement } from "@axl-dev/school-sdk";
import { message } from "antd";
import { useCallback, useEffect, useState } from "react";

import { useDevice } from "@app/shared/lib/DeviceProvider";
import { useSdk } from "@app/shared/lib/hooks";

import {
  AnnouncementMessageContent,
  AnnouncementMessageContentMobile,
} from "./components/AnnouncementMessageContent";

export const AnnouncementMessageQueue: React.FC = () => {
  const sdk = useSdk();
  const [announcementsQueue, setAnnouncementsQueue] = useState<Announcement[]>(
    [],
  );
  const [messageApi, contextHolder] = message.useMessage();
  const [announcementCount, setAnnouncementCount] = useState<number>(1);
  const [totalAnnouncements, setTotalAnnouncements] = useState<number>(0);
  const device = useDevice();

  const getAnnouncements = useCallback(async () => {
    const result = await sdk.announcement.fetch();
    if (result.success) {
      setTotalAnnouncements(result.body.length);
      const sortedAnnouncements = result.body.slice().sort((a, b) => {
        const aInMs = +a.createdDate.toDate();
        const bInMs = +b.createdDate.toDate();

        return bInMs - aInMs;
      });
      setAnnouncementsQueue(sortedAnnouncements);
    }
  }, [sdk.announcement]);

  useEffect(() => {
    getAnnouncements();
  }, [getAnnouncements]);

  const showNextAnnouncement = useCallback(() => {
    if (announcementsQueue.length > 0 && announcementsQueue[0]) {
      const nextAnnouncement = announcementsQueue[0];
      messageApi.open({
        content:
          device.deviceSize !== "mobile" ? (
            <AnnouncementMessageContent
              text={nextAnnouncement.text}
              announcementCount={announcementCount}
              totalAnnouncements={totalAnnouncements}
              onClose={() => {
                sdk.announcement.close(nextAnnouncement.id);
                message.destroy(nextAnnouncement.id);
                setAnnouncementsQueue(announcementsQueue.slice(1));
              }}
            />
          ) : (
            <AnnouncementMessageContentMobile
              text={nextAnnouncement.text}
              announcementCount={announcementCount}
              totalAnnouncements={totalAnnouncements}
              onClose={() => {
                sdk.announcement.close(nextAnnouncement.id);
                message.destroy(nextAnnouncement.id);
                setAnnouncementsQueue(announcementsQueue.slice(1));
              }}
            />
          ),
        duration: 0,
        key: nextAnnouncement.id,
        style: {
          margin: "0 auto",
          maxWidth: 700,
        },
      });
      setAnnouncementCount(announcementCount + 1);
    }
  }, [
    announcementsQueue,
    messageApi,
    device.deviceSize,
    announcementCount,
    totalAnnouncements,
    sdk.announcement,
  ]);

  useEffect(() => {
    showNextAnnouncement();
  }, [announcementsQueue, showNextAnnouncement]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{contextHolder}</>;
};
